import { Moment } from 'moment';
import { OverlayPositionType } from '../../../ThemeProvider/types';
import { DayType } from '../../types';

export interface DateOverlayProps {
  target: string;
  isOpen: boolean;
  makeDays: string[];
  displayDate: string;
  targetHeight: number;
  dayGrid: DayType[];
  singleSelection: boolean;
  momentInstance: Moment;
  inputValue?: InputValueType | null | any;
  overlayPosition?: OverlayPositionType;
  isMobile?: boolean;
  label?: string;
  placeholder?: string;
  overAll?: boolean;
  testId?: string;
  onClose: () => void;
  goBack: () => void;
  goFront: () => void;
  onSelection: (data: InputValueType) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const OVERLAY_WIDTH = 326;
export const OVERLAY_MAX_HEIGHT = 375;

export enum ClickType {
  FirstClick = 0,
  SecondClick,
  OtherClick,
}

export type InputPositionType = {
  width: number;
  top: number;
  bottom: number;
  x: number;
};

type InputValueType = { from: string; until: string } | string;
